module.exports = __webpack_public_path__ + "media/images/front/products/logiq_e_premium/index-banner-6e726bf26b1aedf85cc3d6a81ffd85a3.jpg";